import { DropZoneWrapper } from "../../../Common/DropZoneWrapper";
import { EntityModalForm } from "./EntityModalForm";
import { CRUDFabric } from "../../CRUDFabric";
import { SaveButton } from "../../../components/SaveButton";
import Compressor from "compressorjs";

export const HasAttachments = {

    // GIF excluded: Canvas API reads only the first frame and cannot output GIF,
    // so compression destroys animation and palette-based transparency.
    compressFormats: ['image/jpeg','image/jpg','image/png'],
    maxScaleImagePx:1000,
    isPrepareFiles:false,
    prepareFiles:null,
    QueryData: null,
    isHightQuality: false,
    SuccessCallback: () => {},

    attachmentUrl() {
        console.log(this.id);
        return this.id ? `${this.urlRoot}/${this.id}/add-attachment` : 'restrict';
    },

    async attachFiles(files, callback=()=>{}, addQueryData={}) {

        if (files.length == 0) {
            return;
        }

        const url = this.attachmentUrl();
        const SaveBtn = new SaveButton('#dropzone-modal');
        if ((url == 'restrict' && !this.isPrepareFiles)) {
            callback();
            return;
        };
        SaveBtn.startLoading('Uploading');
        let flag = true;
        $('.dropzone-error-message-container').text('');
        let file_type = "doc"; //указание типа стоит переделать
        let data;
        try {
            data = await this.prepareFilesData(files, file_type, this.isPrepareFiles)
        } catch (e) {
            // Only HEIC conversion throws here. Say what happened and what to do instead —
            // otherwise the upload just dies with the save button spinning.
            if (!e?.heic) throw e;
            SaveBtn.stopLoading(false, 'Upload').then(() => SaveBtn.showError());
            $('.dropzone-error-message-container')
                .text('We could not convert that HEIC photo. Export it as JPEG and try again, or '
                    + 'set your camera to “Most Compatible” (iPhone: Settings › Camera › Formats).')
                .removeClass('d-none');
            return false;
        }
        if (this.isPrepareFiles){
            SaveBtn.stopLoading(true,'Upload').then(() => {
                SaveBtn.showSuccess()
                .then(() => setTimeout(() => {
                    if(this.isPrepareFiles){
                        document.dispatchEvent(new CustomEvent('prepare_files', { detail: { files } }))
                    }
                    this.dropzone.container.modal('hide')
                    delete this.dropzone;
                }, 1000));
            })
            callback()
            return
        }
        for(let key in addQueryData){
            data.append(key,addQueryData[key])
        }
        if (this.QueryData) {
            for(let key in this.QueryData){
                data.append(key,this.QueryData[key])
            }
        }

        $.ajax({
            url,
            method: "POST",
            processData: false,
            contentType: false,
            data,
            success: (response) => {
                SaveBtn.stopLoading(true,'Upload').then(() => {
                    SaveBtn.showSuccess()
                    .then(() => setTimeout(() => {
                        try {
                        this.SuccessCallback(response);
                        } catch (error) {
                            console.error('Error in SuccessCallback:', error);
                        }
                        if (this.dropzone && this.dropzone.container) {
                            this.dropzone.container.modal('hide');
                        }
                        callback(response);
                        if (this.dropzone) {
                        delete this.dropzone;
                        }
                    }, 1000));
                })
            },
            error: (response) => {
                SaveBtn.stopLoading(false,'Upload').then(()=>{
                    SaveBtn.showError()
                })
                let errors = {};
                if (response.status == 413) {
                    errors['filesize'] = ['File is too large. Size limit is 5mb.'];
                } else {
                    errors = response.responseJSON.errors;
                }

                if (errors) {
                    $('.dropzone-error-message-container').text('Error: ');
                    Object.values(errors)[0].forEach(element => {
                        $('.dropzone-error-message-container').append('<br>'+element);
                    });
                    $('.dropzone-error-message-container').removeClass('d-none');
                }
                flag = false;
            }
        });
        return flag;
    },

    deleteAttachment(fileId, entityId, fileBox, cb=()=>{}){
        let url = entityId ? `${this.urlRoot}/${entityId}/delete-attachment` : 'restrict';
        if(url == 'restrict' || fileId == null){
            cb()
            return
        }
        let data = new FormData()
        data.append('fileId', fileId)
        $.ajax({
            url,
            method: "POST",
            processData: false,
            contentType: false,
            data,
            success: (response) => {
                fileBox.remove();
                $('.dropzone-error-message-container').addClass('d-none');
                cb(response);
            },
            error: (response) => {
                let errors = response.responseJSON.errors;
                if (errors) {
                    $('.dropzone-error-message-container').text('Error: ');
                    Object.values(errors)[0].forEach(element => {
                        $('.dropzone-error-message-container').append('<br>'+element);
                    });
                    $('.dropzone-error-message-container').removeClass('d-none');
                }
            }
        });
    },

    setAttachmentCallbackDelete(callback=()=>{}){
        $('body').off('click','.delete-file-btn').on('click','.delete-file-btn',(e)=>{
            let entityObj = this
            let parent = $(e.currentTarget).parents('[data-file-item]')[0]
            const entity = $(e.currentTarget).data('entity')
            const fileId = $(e.currentTarget).data('file-id')
            const entityId = $(e.currentTarget).data('entity-id')
            if(!fileId || !entityId ||!entity)
                return
            const Entity = CRUDFabric.getClass(entity)
            if(!(entityObj instanceof Entity)){
                entityObj = new Entity(entityId)
            }
            entityObj.deleteAttachment(fileId,entityId,parent)
            setTimeout(() => {
                callback();
            }, 200);
        })
    },

    setAttachmentCallbackPreview(){
        $('body').off('click','.preview-file-btn').on('click','.preview-file-btn',(ev)=>{
            ev.stopPropagation(); // Prevent click from bubbling to parent .edit-line
            $('#preview-modal #preview-image').attr('src', $(ev.currentTarget).data('src'))
            $('#preview-modal').modal('show');
        })
    },

    /**
     * Turn any HEIC/HEIF the user picked into a JPEG, in the browser, before anything is sent.
     *
     * Owner 2026-07-27: "Can it client side js script only? Dont want to be sending those files
     * to server. WE compress them in the browser." Converting server-side would mean shipping
     * the untouched file up first, which is the opposite of how uploads work here.
     *
     * HEIC is what Samsung and Pixel cameras can save, and what an iPhone hands over when the
     * raw file is copied to a PC. Nothing in the stack can read it — the server has GD only, no
     * libheif — so before this a worker on a photo-required step was simply stuck.
     *
     * The decoder is ~3MB, so it is imported DYNAMICALLY: webpack splits it into its own chunk
     * and the browser only ever fetches it if someone actually picks a HEIC. Normal uploads pay
     * nothing. The converted JPEG then goes through the ordinary compressorjs shrink like every
     * other photo, so it is still resized to 1000px before it leaves the machine.
     */
    async convertHeicFiles(files) {
        const isHeic = (f) => /^image\/hei[cf]/i.test(f?.type || '') || /\.hei[cf]$/i.test(f?.name || '');
        if (!Array.from(files).some(isHeic)) {
            return files;   // the overwhelmingly common path — decoder never downloaded
        }

        let heicTo;
        try {
            ({ heicTo } = await import(/* webpackChunkName: "heic-decoder" */ 'heic-to'));
        } catch (e) {
            console.error('HEIC decoder failed to load', e);
            const err = new Error('heic-decoder-unavailable');
            err.heic = true;
            throw err;
        }

        const out = [];
        for (const file of Array.from(files)) {
            if (!isHeic(file)) { out.push(file); continue; }
            try {
                const blob = await heicTo({ blob: file, type: 'image/jpeg', quality: 0.9 });
                // Rename too: a JPEG still called .heic confuses every later reader of the name.
                const name = file.name.replace(/\.hei[cf]$/i, '') + '.jpg';
                const converted = new File([blob], name, { type: 'image/jpeg' });
                // Carry Dropzone's bookkeeping across, but with the NEW name. prepareFilesData
                // below renames each file back to `upload.filename`, so leaving the original
                // there stored a perfectly good JPEG under a .heic name — content converted,
                // label lying. Caught by inspecting the stored file, not the upload.
                if (file.upload) {
                    converted.upload = Object.assign({}, file.upload, { filename: name });
                }
                out.push(converted);
            } catch (e) {
                console.error('HEIC conversion failed for ' + file.name, e);
                const err = new Error('heic-conversion-failed');
                err.heic = true;
                throw err;
            }
        }
        return out;
    },

    async prepareFilesData(files, file_type=null, isPrepare=false) {
        // Before anything else: a HEIC becomes a JPEG, so everything downstream — the shrink,
        // the validation, the server — only ever deals with formats it understands.
        files = await this.convertHeicFiles(files);

        let data = new FormData()
        for(let i=0; i<files.length; i++){
            if(files[i]?.upload?.filename && files[i].name != files[i].upload.filename)
                files[i] = new File([files[i]], files[i].upload.filename ,{type: files[i].type})
        }
        let options = {};
        if (this.isHightQuality) {
            options = {
                'quality': 0.9,
                'convert_size':150000,
            };
        }
        files = await this.zipImages(files, options)
        for(let key in files){
            if (file_type !==null) {
                data.append('files[' + file_type + '][]', files[key]);
            }else{
                data.append('files[' + files[key].type + '][]', files[key]);
            }
        }
        if(isPrepare){
            if(this.prepareFiles instanceof FormData){
                for (const [key, file] of data.entries()) {
                    this.prepareFiles.append(key, file);
                }
            }else{
                this.prepareFiles = data
            }
        }
        return data;
    },

    async zipImages(files, options = {}){
        try{
            let quality = options.quality ?? 0.6;
            let size=options.convert_size ?? 100000;

            const promisses = []
            const images = files.filter(f=>this.compressFormats.includes(f.type))
            if(!images.length)
                return files
            for(let image of images){
                promisses.push(this.compressImage(image, size, quality))
            }
            let results = (await Promise.allSettled(promisses)).filter(r=>r!=false && r?.status=='fulfilled')
                                                                .map(r=>r.value)
            results = [...results, ...files.filter(f=>!this.compressFormats.includes(f.type))]
            return results
        }catch(err){
            console.error(err)
            return false
        }
    },

    compressImage(file, convert_size=100000, quality=0.6) {
        return new Promise(resolve => {
            new Compressor(file, {
                convertTypes: ['image/png'],
                convertSize: convert_size,
                quality: quality,
                maxWidth: this.maxScaleImagePx,
                maxHeight: this.maxScaleImagePx,
                success: (result) => {
                    let resultFile = new File([result], result.name, {type: result.type})
                    resultFile.upload = file.upload
                    resolve(resultFile);
                },
                err: (err)=>{
                    resolve(false)
                }
            });
        });
    },

    openDropZone(options={}, addQueryData={}, callback = () =>{}) {

        if (this.dropzone) delete this.dropzone;
        let local_options = {
            modal: {
                template: '#dropzone',
                selector: '#dropzone-modal',
                submit: {
                    element: '#submit-attachments',
                    event: 'click',
                    handler: (files, callback=()=>{}) => {
                        //console.log(callback);
                        this.attachFiles(files, callback, addQueryData);
                    }
                },
                remove_file: {
                    element: '.delete-file-button',
                    event: 'click',
                    handler: (files) => {
                        console.log(files);
                        if (files.length == 0) {
                            $('#submit-attachments').attr('disabled', 'disabled');
                        }
                    }
                }
            },
            successCallback: callback,
        };
        let complete_options = Object.assign(local_options, options);
        let dzConfig = {
            url: this.attachmentUrl()
        };
        if(options?.accessFileType){
            dzConfig.accessFileType = options.accessFileType;
        }
        this.dropzone = DropZoneWrapper.init(complete_options, dzConfig);
        //window.dropzone = this.dropzone;

        return this.dropzone;
    },


    viewAttachments() {
        $.ajax({
            url: `${this.urlRoot}/${this.id}/view-attachments`,
            success: (response) => {
                EntityModalForm.pasteForm(response);

                const attachmentsModal = $(`#attachments-modal`);
                attachmentsModal.modal('show');

                $(document).off('added_file').on('added_file', (e) => {
                    const attachTemplate = document.querySelector('#attachment-row-template')
                    if(attachTemplate && e?.detail?.file){
                        const file = e.detail.file
                        const newPreview = attachTemplate.cloneNode(true)
                        newPreview.removeAttribute('id')
                        newPreview.classList.add('d-flex')
                        newPreview.classList.add('d-none')
                        newPreview.querySelector(`[data-file-type="${/^image\/.*/.test(file.type)? 'doc':'img'}"]`).remove()
                        const downloadLink = newPreview.querySelector('.attachment__link')
                        download.href = URL.createObjectURL(file)
                        download.download = file.upload.filename
                        if(/^image\/.*/.test(file.type)){
                            const previewLink = newPreview.querySelector('.preview-file-btn')
                            if(previewLink){
                                previewLink.setAttribute('data-src',URL.createObjectURL(file))
                                previewLink.classList.remove('d-none')
                            }
                        }
                        let newNameArr = file.upload.filename.split('.')
                        newNameArr[0]=newNameArr[0]+'_new'
                        newNameArr[0] = newNameArr[0].length > 20 ? '...'+newNameArr[0].slice(0,20) : newNameArr[0]
                        newPreview.querySelector('.filename').textContent = newNameArr.join('.')
                        attachmentsModal.find('#attachments-container').append(newPreview);
                    }
                });
            }
        });
    },

    scopeOpenDropZoneListener(addQueryData={}, callback = ()=>{}) {
        $('body')
            .off('click', '.upload-files')
            .on('click', '.upload-files', (e) => {
                let ftype = $(e.currentTarget).data('file_type')
                const id = $(e.currentTarget).data('id')
                const entity = $(e.currentTarget).data('entity')
                // A trigger may carry extra POST fields as data-upload-extra='{"k":"v"}'.
                // The checklist uses it to say which step a photo belongs to, so a caller does
                // not have to re-bind this listener for every row on the page.
                const extra = $(e.currentTarget).data('upload-extra') || {}
                const query = Object.assign({}, addQueryData, extra)
                const done = (response) => {
                    // Let anything on the page react without owning the dialog. Carries what was
                    // uploaded plus the extra fields, so a listener can tell whose upload it was.
                    document.dispatchEvent(new CustomEvent('attachments_stored', {
                        detail: { response, entity, id, extra },
                    }))
                    callback(response)
                }
                if(id && entity && (this?.entityClass != entity || this?.id != id)){
                    const entityClass = CRUDFabric.getClass(entity)
                    if(entityClass){
                        let objEntity = new entityClass(id)
                        if(objEntity?.openDropZone)
                            objEntity.openDropZone({accessFileType:ftype}, query, done)
                    }
                }else{
                    this.openDropZone({accessFileType:ftype}, query, done);
                }
            });
    },

    create(successCallback=this.callbackCloseModal, errorCallback=()=>{}, method='PUT') {
        const formId = `create-${this.entityClass}`;
        const data = this.collectDataInForm(formId);
        // Scope to the form, the same way CRUDEntity.create() does. Unscoped, SaveButton falls
        // back to the FIRST button[data-save] anywhere in the document, and several modals sit in
        // the DOM at once here — so it drove the wrong button, or none at all. This mixin
        // OVERRIDES CRUDEntity.create() (it is Object.assign'd onto the prototype last), so every
        // entity mixing in HasAttachments silently lost its save feedback: the record saved and
        // the button never moved. Proven with drafts/modal-verify/fm-spy-lifecycle.cjs, which
        // showed zero lifecycle calls during a save that returned 200.
        const SaveBtn = new SaveButton(`#${formId}`);
        let addParams = {}
        if(data instanceof FormData){
            addParams={
                processData: false,
                contentType: false,
                cache: false,
            }
        }
        $.ajax({
            url: `${this.urlRoot}/create`,
            method: method,
            data: data,
            ...addParams,
            beforeSend: () => {
                SaveBtn.startLoading();
            },
            success: (response) => {
                this.id = response.id;
                if(this.dropzone) {
                    this.dropzone.updateConfig({url: this.attachmentUrl()});
                    this.dropzone.dispatchOwnerCreated();
                }
                SaveBtn.stopLoading(true).then(() => {
                    SaveBtn.showSuccess()
                    .then(()=>successCallback(response))
                    .then(result => {
                        if(result) setTimeout(() => window.location.reload(), 500)
                    });
                })
            },
            error: (response) => {
                SaveBtn.stopLoading().then( () => {
                    SaveBtn.showError().then(() => {
                        errorCallback(response)
                    })
                })
            }
        })
    }
}
